export default {"src":"/_next/static/media/carIcon.61985529.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};